import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontSizeTokens, IconSizeTokens, IconTokens, SizeTypeTokens, StackAlignItems, StackJustifyContent, } from '@voltmoney/schema';
import React, { memo } from 'react';
import { Platform, Text, View } from 'react-native';
import Icon from '../icon/Icon';
import Space from '../space/Space';
import Typography from '../typography/Typography';
import { Component as Stack } from '../stack';
import Button from '../button/Button';
import ThemeProvider from '@voltmoney/theme';
/**
 * Raw Component with Derived props + Theme
 */
const VerificationCardBase = ({ id, onPress, label, message, buttonText, triggerAction, action, loading = false, titleFont = true, shouldAutoNavigate, }) => {
    const theme = ThemeProvider.getTheme();
    return (React.createElement(View, { style: [
            {
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: theme.colors[ColorTokens.White],
                borderRadius: 12,
                padding: 16,
                paddingBottom: Platform.OS === "ios" ? 12 : 0
            },
        ] },
        React.createElement(Stack, { justifyContent: StackJustifyContent.center, alignItems: StackAlignItems.center },
            React.createElement(Space, { size: SizeTypeTokens.XXXXL }),
            React.createElement(Icon, { name: IconTokens.Success, color: ColorTokens.Green_10, size: IconSizeTokens.Size56 }),
            React.createElement(Space, { size: SizeTypeTokens.XL }),
            React.createElement(Text, { style: {
                    textAlignVertical: 'center',
                    textAlign: 'center',
                } },
                React.createElement(Typography, { label: label, color: ColorTokens.Grey_Night, fontWeight: titleFont ? '600' : 'bold', fontSize: FontSizeTokens.XL, numberOfLines: 2 })),
            React.createElement(Space, { size: SizeTypeTokens.SM }),
            message !== '' && (React.createElement(View, { style: {
                    justifyContent: 'center',
                    alignItems: 'center',
                } }, message !== '' && (React.createElement(Text, { style: {
                    textAlignVertical: 'center',
                    textAlign: 'center',
                    flexWrap: 'wrap',
                } },
                React.createElement(Typography, { label: message, color: ColorTokens.Grey_Charcoal, fontWeight: '400', fontSize: FontSizeTokens.SM }))))),
            React.createElement(Space, { size: SizeTypeTokens.XXXXXXL }),
            buttonText !== '' && (React.createElement(Button, { id: id, label: buttonText, action: action, triggerAction: triggerAction, type: shouldAutoNavigate ? ButtonTypeTokens.LargeSoftFilled : ButtonTypeTokens.LargeFilled, width: ButtonWidthTypeToken.FULL, onPress: onPress, loading: loading })))));
};
export default memo(VerificationCardBase);
export { VerificationCardBase };
